import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=2f355950"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=2f355950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports